import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Stack, Typography } from "@mui/material";

import {
  getDefaultValues,
  useAuth,
  VALIDATION_SCHEMA,
} from "@/features/authentication";
import { CustomInputField, PasswordField, useSnackbar } from "@/features/ui";
import { getErrorMessage } from "@/features/shared";

export const Login = () => {
  const { login } = useAuth();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "dashboard";

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: getDefaultValues(),
    resolver: yupResolver(VALIDATION_SCHEMA),
  });

  const onSubmit = async ({ username, password }) => {
    try {
      const user = await login({ username, password });

      if (user.passwordConfirmedAt) {
        navigate(from, { replace: true });
      } else {
        navigate("/renew-password", { replace: true });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        showSnackbar("Username atau password salah.");
      } else {
        showSnackbar(getErrorMessage(error, "Gagal masuk. Silakan coba lagi"));
      }
    }
  };

  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center"
      }}>
      <img src="logo.png" style={{ height: "11.625rem" }} />
      <Typography
        variant="h4"
        sx={{
          paddingX: 4,
          mt: 4
        }}>
        Back Office
      </Typography>
      <Stack
        spacing={2}
        component="form"
        sx={{
          mt: 6,
          width: 300,
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <CustomInputField
          required
          name="username"
          label="Username"
          register={register}
          helperText={errors.username?.message}
          error={Boolean(errors.username)}
        />
        <PasswordField
          required
          name="password"
          label="Password"
          register={register}
          helperText={errors.password?.message}
          error={Boolean(errors.password)}
          sx={{ mt: 2.5 }}
        />
        <Button loading={isSubmitting} variant="contained" type="submit">
          Login
        </Button>
      </Stack>
    </Stack>
  );
};
